import nullable from "../nullable";
import * as t from "io-ts";
import { orderStatusT } from "../order";
export const createOrderViews = ({ dateTime, }) => {
    const placeT = t.strict({
        country: nullable(t.string),
        postcode: nullable(t.string),
        city: nullable(t.string),
    });
    const documentT = t.strict({
        id: t.string,
        name: t.string,
        fileType: t.string,
    });
    const orderViewT = t.strict({
        id: t.string,
        ref: t.string,
        createdAt: dateTime,
        from: nullable(placeT),
        to: nullable(placeT),
        status: orderStatusT,
        documents: t.array(documentT),
        invoiceRef: nullable(t.string),
    });
    const orderViewsT = t.array(orderViewT);
    return { placeT, orderViewT, orderViewsT };
};
//# sourceMappingURL=order-view.js.map